import { Checkbox } from '@pluxee-design-system/core';
import { getCheckBoxValue } from 'common/forms/utils';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { LocationEmployeeItem } from 'generated/models';
import { get } from 'lodash';
import { ChangeEvent, useCallback } from 'react';
import { useController } from 'react-hook-form';

const LocationContactCell = ({
  row: { contact, contactEnabled, location },
  extra: isDisabled,
}: ComponentProps<LocationEmployeeItem, boolean, boolean>) => {
  const { field } = useController({ name: 'locationsContact' });
  const { onChange } = field;
  const index = location.uid;
  const currentValue = get(field.value, `${index}.newState`, contact ?? false);
  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      onChange(getCheckBoxValue(contact, event.target.checked, field.value, index)),
    [contact, field.value, index, onChange],
  );

  return (
    <Checkbox
      name={`locationsContact.${index}.newState`}
      isDisabled={isDisabled || !contactEnabled}
      id={`locationsContact.${index}`}
      isChecked={currentValue}
      onChange={handleOnChange}
    />
  );
};

export default LocationContactCell;
